import * as React from "react"

export default function MotorikIcon(props) {
  return (
    <svg
      width={160}
      height={20}
      viewBox="0 0 160 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.071 0h-.095l-4.929 4.929L5.118 0h-.094L0 5v15h5.118V6.92l4.93 4.928 4.928-4.929V20h5.119V5L15.07 0z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.957 0H28.91l-5.024 5v10l5.024 5h10.047l5.024-5V5l-5.024-5zm-9.952 5.213h9.858v9.858h-9.858V5.213z"
        fill={props.fill}
      />
      <path
        d="M54.166 20h4.929V4.929h7.393V0H46.773v4.929h7.393V20z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.35 0H74.304L69.28 5v10l5.023 5h10.048l5.023-5V5l-5.023-5zm-9.952 5.213h9.858v9.858h-9.858V5.213z"
        fill={props.fill}
      />
      <path
        d="M98.095 20h-4.93V0h19.717v11.943l-2.844 2.844L115.251 20h-7.014l-5.213-5.213v-4.93h4.929V4.93h-9.858V20zM116.673 20v-4.929h7.393V4.93h-7.393V0h19.716v4.929h-7.394V15.07h7.394V20h-19.716zM140.18 0h4.929v7.76l7.77-7.76h6.98l-9.992 9.993L159.874 20h-6.971l-7.794-7.794V20h-4.929V0z"
        fill={props.fill}
      />
    </svg>
  )
}


